import IconWidget from '@arpav/components/ArpavTheme/manage/Widgets/IconWidget/IconWidget';

export default IconWidget;
